module.exports = __webpack_public_path__ + "img/006ff66d6e575d60465c1516480f6ad4.png";